module.exports = __webpack_public_path__ + "static/img/bg1.5863359.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/bg1.png
// module id = e3jH
// module chunks = 0